import { type FC } from 'react'

import { SearchInput } from './SearchInput'
import type { SearchProps } from './types'

/**
 * Search - Remote search component for Select
 *
 * Remote search component (via API).
 * Emits search changes via onSearch to allow parent to manage filtering.
 * Renders SearchInput which uses context to retrieve values.
 *
 * @example
 * ```tsx
 * <Select mode="single" value={value} onChange={setValue}>
 *   <Select.Search onSearch={handleSearch} placeholder="Search..." />
 * </Select>
 * ```
 */
const SearchComponent: FC<SearchProps> = ({ placeholder }) => {
  // Renders SearchInput which retrieves values via useSelectSearch hook
  return <SearchInput placeholder={placeholder} />
}

SearchComponent.displayName = 'SelectSearch'

export const Search = SearchComponent
